var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThanks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 48,
    viewBox: "0 0 62 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_1652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8395 17.3168C61.8395 19.9962 60.8207 22.6756 58.773 24.7233L43.6135 39.8828C41.9121 41.5842 39.1512 41.5842 37.4601 39.8828L22.2904 24.7233C18.2051 20.6278 18.2051 14.0058 22.2904 9.91025C24.328 7.8625 27.0175 6.84372 29.6969 6.84372C32.3763 6.84372 35.0659 7.8625 37.1035 9.91025L40.5368 13.3334L43.7765 10.0936C47.8822 5.98794 54.6061 5.78419 58.7322 9.8695C60.8003 11.9274 61.8395 14.617 61.8395 17.3168Z",
    fill: "url(#paint0_linear_239_1652)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_239_1652)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_239_1652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8633 10.1311C45.7943 12.723 45.7398 15.6689 44.4704 18.3614L35.0734 38.2934C34.0188 40.5304 31.3481 41.4897 29.1209 40.4315L9.17906 31.0381C3.80406 28.4958 1.50307 22.09 4.03192 16.7086C5.29142 14.0198 7.53919 12.0997 10.1311 11.1687C12.723 10.2376 15.6788 10.2886 18.3613 11.5615L22.872 13.6799L24.8802 9.4202C27.4252 4.02195 33.8588 1.48845 39.2697 4.00669C41.9854 5.27881 43.9252 7.5195 44.8633 10.1311Z",
    fill: "white",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.8056 24.9901C27.5314 24.4437 28.4875 22.602 27.9412 20.8764C27.395 19.1508 25.5531 18.1948 23.8274 18.7412C22.1016 19.2875 21.1455 21.1293 21.6917 22.8548C22.238 24.5804 24.0799 25.5364 25.8056 24.9901Z",
    fill: "url(#paint1_linear_239_1652)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.1292,
    cy: 15.9509,
    rx: 1.15625,
    ry: 1.15625,
    fill: "url(#paint2_linear_239_1652)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_239_1652",
    x: -11.9951,
    y: -11.9717,
    width: 72.4957,
    height: 67.834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_239_1652"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_239_1652",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_1652",
    x1: 43.6701,
    y1: 26.2992,
    x2: 9.74316,
    y2: 46.7842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E02232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_239_1652",
    x1: 23.8274,
    y1: 18.7412,
    x2: 25.8056,
    y2: 24.9901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_239_1652",
    x1: 27.1292,
    y1: 14.7946,
    x2: 28.2854,
    y2: 17.7626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_1652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.6156,
    height: 34.3126,
    fill: "white",
    transform: "translate(19.2239 6.84372)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_239_1652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.803,
    height: 35.2686,
    fill: "white",
    transform: "translate(0 14.8078) rotate(-19.7583)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanks);
export default __webpack_public_path__ + "static/media/thanks.20003f852e71dc141c266bf15209f253.svg";
export { ForwardRef as ReactComponent };